import type { TransactionStatus } from "../types";

const LABELS: Record<TransactionStatus, string> = {
  unmatched: "Open",
  suggested: "Needs confirm",
  matched: "Matched",
  rejected: "Rejected",
  excluded: "No receipt",
  insufficient: "Insufficient",
};

export function StatusBadge({ status }: { status: TransactionStatus }) {
  return <span className={`badge badge-${status}`}>{LABELS[status]}</span>;
}
